module.exports = __webpack_public_path__ + "img/poster.b8f7e196.png";